/*
 * @Descripttion:
 * @version:
 * @Author: xiaocy
 * @Date: 2019-09-19 09:40:19
 * @LastEditors: xiaocy
 * @LastEditTime: 2019-09-19 09:40:19
 */
import { callApi } from '@/utils/request'
import api  from '../apis/user'
import User from '../models/user'
// import { callVenusApi } from '@/utils/requestVenus';

export async function get() {
    
    return callApi<User>(api.get);
}

export async function valid(uid: string , password: string) {
    return callApi<{ token: string}>(api.valid, {
        data: {
            name: uid,
            password
        }
    })

}
